// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZW8l6GF1poRWNvas{display:flex;justify-content:flex-end;align-items:center;gap:8px;margin-right:8px}.ZW8l6GF1poRWNvas .ZdoZAD1UAaO6iDrr{height:24px;width:150px;margin:0}.ZW8l6GF1poRWNvas .Qj5jq2prOy8PDJCe{margin-left:8px;width:180px}.kJEcZ3o2WQ4W0cYL{margin-top:16px}.kJEcZ3o2WQ4W0cYL .Sx16hUPLFoVqVRl8{white-space:nowrap}.kJEcZ3o2WQ4W0cYL .kSOewBwS0j8Y5pFJ div{gap:8px}.fKtxKJuIkUu3Zw91{display:flex;align-items:center;white-space:wrap}.fKtxKJuIkUu3Zw91 .JPJsiARyWSMK1G4h{padding:2px;font-size:9px;align-self:flex-start;color:var(--py-primary-9);opacity:.7}.fKtxKJuIkUu3Zw91 .JPJsiARyWSMK1G4h:hover{opacity:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toolbar": `ZW8l6GF1poRWNvas`,
	"select": `ZdoZAD1UAaO6iDrr`,
	"search": `Qj5jq2prOy8PDJCe`,
	"cardBody": `kJEcZ3o2WQ4W0cYL`,
	"bodyCell": `Sx16hUPLFoVqVRl8`,
	"headCell": `kSOewBwS0j8Y5pFJ`,
	"questionWrapper": `fKtxKJuIkUu3Zw91`,
	"infoIcon": `JPJsiARyWSMK1G4h`
};
export default ___CSS_LOADER_EXPORT___;
